import { State } from '../state.interface';
import * as Actions from '../actions';
import { assocPath } from 'ramda';

/**
 * Reducer to set the useCategories property in the state.
 * @param state - The current state of the variable editor dialog.
 * @param action - The action containing the new value for useCategories.
 * @returns The updated state with the new useCategories value.
 */
export const setUseCategoriesReducer = (state: State, action: Actions.SetUseCategories) => {
  const updatedState = assocPath<boolean, State>(['useCategories'], action.payload.value, state);
  return updatedState;
};
